var _defs, _polygon, _path, _polygon2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 155.19 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #212529;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 1.06 13.88 1.06 20.59 29.2 20.69 29.2 27.61 1.06 41.33 1.06 41.33 38.93 32.39 38.93 32.39 9.52 32.29 9.52 24.79 38.93 16.44 38.93 8.72 9.52 8.62 9.52 8.62 38.93 0 38.93 0 1.06"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.76,40c-12.07,0-19.15-9.36-19.15-20S50.68,0,62.76,0s19.15,9.36,19.15,20-7.08,20-19.15,20m0-32.02c-5.53,0-9.68,3.51-9.68,12.02,0,5.53,2.23,12.02,9.68,12.02,7.02,0,9.68-6.17,9.68-12.02s-2.66-12.02-9.68-12.02"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "84.4 1.06 93.97 1.06 107.75 25.27 107.85 25.27 107.85 1.06 116.47 1.06 116.47 38.93 107 38.93 93.12 15.11 93.01 15.11 93.01 38.93 84.4 38.93 84.4 1.06"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M131.09,1.06h9.79l14.31,37.87h-10.16l-1.91-5.96h-13.99l-1.91,5.96h-10.11L131.09,1.06Zm9.73,24.89l-4.68-15.64h-.11l-4.68,15.64h9.47Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonaLogo);
export default __webpack_public_path__ + "static/media/Mona Logo.16f8ff7c263667893da1ebdcb019d0ff.svg";
export { ForwardRef as ReactComponent };